// extracted by mini-css-extract-plugin
export var centerText = "_cv-8";
export var container = "_cv-0";
export var doughnutContainer = "_cv-7";
export var legend = "_cv-a";
export var legendItemColorDisplay = "_cv-b";
export var legendItemLabel = "_cv-d";
export var legendItemValue = "_cv-c";
export var lg = "_cv-5";
export var maxWidth = "_cv-9";
export var md = "_cv-4";
export var responsive = "_cv-6";
export var sm = "_cv-3";
export var xs = "_cv-2";
export var xxs = "_cv-1";